import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { ActivityIndicator } from 'react-native';

export const WeixinBindStatusLabel = memo(
  ({ status, error }: { status: boolean | null; error?: Error }) => {
    const { rpx } = useResponsiveContext();
    if (status === null) {
      return (
        <ActivityIndicator
          size="small"
          color={'#777'}
          css={`
            transform: scale(${rpx(0.7)});
            margin-right: ${rpx(10)}px;
          `}
        />
      );
    }
    if (error != null) {
      return (
        <Icon
          name="warning"
          color={StatusColors.Danger}
          size={rpx(18)}
          css={`
            margin-right: ${rpx(10)}px;
          `}
        />
      );
    }

    if (status) {
      return (
        <Typography.Label
          light
          size={rpx(15)}
          color={StatusColors.Success}
          css={`
            margin-right: ${rpx(10)}px;
          `}
        >
          已绑定
        </Typography.Label>
      );
    }

    return (
      <Typography.Label light size={rpx(15)} color={StatusColors.Warn}>
        未绑定
      </Typography.Label>
    );
  },
);
